export default function Footer() {
  return (
    <footer role="contentinfo" className="bg-primary-950 text-background-50 px-6 md:px-16 lg:px-24 pt-16 pb-8">
      <div className="max-w-7xl mx-auto" itemScope itemType="https://schema.org/LocalBusiness">
        <meta itemProp="name" content="株式会社Wind" />
        <meta itemProp="telephone" content="+81-3-6379-2823" />
        <meta itemProp="email" content="info@wind-service0120.com" />
        <meta itemProp="address" content="〒156-0043 東京都世田谷区松原3-30-10 双葉屋ビル 2F" />
        <meta itemProp="openingHours" content="Mo-Tu,Th-Sa 09:00-18:00" />
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12 border-b border-background-50/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-11 h-11 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-home-4-line text-background-50 text-xl"></i>
              </span>
              <div className="flex flex-col leading-none">
                <span className="text-[10px] tracking-[0.3em] uppercase text-background-50/60">
                  Kabushiki-gaisha
                </span>
                <span className="font-heading text-2xl font-bold tracking-wide">Wind</span>
              </div>
            </div>
            <p className="text-sm text-background-50/70 leading-relaxed max-w-md mb-6">
              東京都・神奈川県を中心に、原状回復・内装リフォーム・
              ハウスクリーニングまで総合対応する地域密着の総合建設会社です。
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: "ri-instagram-line", href: "#", label: "Instagram" },
                { icon: "ri-line-fill", href: "#", label: "LINE" },
                { icon: "ri-twitter-x-line", href: "#", label: "X(Twitter)" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-10 h-10 rounded-full bg-background-50/10 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-background-50`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold mb-5 tracking-wider">
              <a href="#services" className="hover:text-primary-300 transition-colors">
                Services
              </a>
            </h4>
            <ul className="space-y-3 text-sm text-background-50/70">
              <li><a href="#services" className="hover:text-primary-300 transition-colors cursor-pointer">原状回復工事</a></li>
              <li><a href="#services" className="hover:text-primary-300 transition-colors cursor-pointer">内装リフォーム</a></li>
              <li><a href="#services" className="hover:text-primary-300 transition-colors cursor-pointer">リノベーション</a></li>
              <li><a href="#services" className="hover:text-primary-300 transition-colors cursor-pointer">ハウスクリーニング</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-bold mb-5 tracking-wider">
              <a href="#company" className="hover:text-primary-300 transition-colors">
                Company
              </a>
            </h4>
            <ul className="space-y-3 text-sm text-background-50/70">
              <li><a href="#company" className="hover:text-primary-300 transition-colors cursor-pointer">会社概要</a></li>
              <li><a href="#area" className="hover:text-primary-300 transition-colors cursor-pointer">対応エリア</a></li>
              <li><a href="#works" className="hover:text-primary-300 transition-colors cursor-pointer">施工事例</a></li>
              <li><a href="/privacy-policy" className="hover:text-primary-300 transition-colors cursor-pointer">プライバシーポリシー</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-bold mb-5 tracking-wider">Contact</h4>
            <ul className="space-y-3 text-sm text-background-50/70">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-primary-300"></i>
                <span>03-6379-2823</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-300"></i>
                <span>info@wind-service0120.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-primary-300"></i>
                <span>東京都世田谷区松原3-30-10 双葉屋ビル 2F</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 pt-6">
          <p className="text-xs text-background-50/60">
            © 2018-2026 株式会社Wind All Rights Reserved.
          </p>
          <p className="text-[10px] tracking-[0.3em] uppercase text-background-50/40">
            Design with care · Tokyo
          </p>
        </div>
      </div>
    </footer>
  );
}